import { Component } from '@angular/core';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { clearStorage, getUsuarioLogado } from './arquitetura/service/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [
    'app.component.scss',
  ],
})
export class AppComponent {
  label = environment.label;
  theme = environment.theme_name;

  logado: boolean;
  financeiro: boolean;
  transferencia: boolean;
  vendas: boolean;
  ofertas: boolean;
  indicacoes: boolean;

  constructor(
    private menu: MenuController,
    private platform: Platform,
    private navCtrl: NavController,
    private route: ActivatedRoute,
    private router: Router) {

  }

  ngOnInit(): void {
    this.platform.ready().then(() => {
      this.verificarLogin();
      // this.navCtrl.navigateForward(['/core/fsk']);
      // this.router.navigate(['/core/ofertas']);
      // this.navCtrl.navigateForward('/core/ofertas', { queryParams: { texto: 'ALLEN' } });
      // this.navCtrl.navigateForward('/core/ofertas', { queryParams: { texto: 'macho' } });
    });
  }

  verificarLogin() {
    var usuario = JSON.parse(getUsuarioLogado());
    if (usuario)
      this.logado = true;
  }

  fecharMenu() {
    this.menu.close('menuPrincipal');
  }

  abrirEAD() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/ead/ead']);
  }

  abrirRodadaNegocio() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/rodada-de-negocios/meu-video-pitch']);
  }

  abrirFinanceiro() {
    this.financeiro = !this.financeiro;
    this.transferencia = false;
    this.vendas = false;
    this.ofertas = false;
    this.indicacoes = false;
  }

  abrirSaldoExtrato() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/financeiro/saldo']);
  }

  abrirEstornos() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/financeiro/estornos']);
  }

  abrirSaldoExpirar() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/financeiro/expirar']);
  }

  abrirMeusEmprestimos() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/financeiro/meus-emprestimos']);
  }

  abrirMeusEmprestimosEmRS() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/financeiro/meus-emprestimos-em-rs']);
  }

  abrirSolicitarEmprestimo() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/financeiro/solicitar-emprestimo']);
  }

  abrirSolicitarAntecipacao() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/financeiro/solicitar-antecipacao']);
  }

  abrirTransferencia() {
    this.financeiro = false;
    this.transferencia = !this.transferencia;
    this.vendas = false;
    this.ofertas = false;
    this.indicacoes = false;
  }

  abrirMinhasTransferencias() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/transferencias/minhas-transferencias']);
  }

  abrirFazerTransferencia() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/transferencias/fazer-transferencia']);
  }

  abrirSolicitarTransferencia() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/transferencias/solicitar-transferencia']);
  }

  abrirVendas() {
    this.financeiro = false;
    this.transferencia = false;
    this.vendas = !this.vendas;
    this.ofertas = false;
    this.indicacoes = false;
  }

  abrirPainelVendas() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/vendas/painel-vendas']);
  }

  abrirValidarVoucher() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/vendas/validar-voucher']);
  }

  abrirCompras() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/compras/painel-compras']);
  }

  abrirParceiros() {
    if (this.logado) {
      this.financeiro = false;
      this.transferencia = false;
      this.vendas = false;
      this.ofertas = !this.ofertas;
      this.indicacoes = false;
    } else {
      this.menu.close('menuPrincipal');
      this.navCtrl.navigateForward(['/core/parceiros']);
    }
  }

  abrirOfertas() {
    if (this.logado) {
      this.financeiro = false;
      this.transferencia = false;
      this.vendas = false;
      this.ofertas = !this.ofertas;
      this.indicacoes = false;
    } else {
      this.menu.close('menuPrincipal');
      this.navCtrl.navigateForward(['/core/ofertas']);
    }
  }

  abrirMinhasOfertas() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/minhas-ofertas/painel-ofertas']);
  }

  abrirCadastroOferta() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/minhas-ofertas/painel-ofertas-cadastro']);
  }

  abrirIndicacoes() {
    this.financeiro = false;
    this.transferencia = false;
    this.vendas = false;
    this.ofertas = false;
    this.indicacoes = !this.indicacoes;
  }

  abrirMinhasIndicacoes() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/indicacoes/painel-indicacao']);
  }

  abrirNovaIndicacao() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/indicacoes/painel-minhas-indicacoes']);
  }

  onSair() {
    clearStorage();
    this.navCtrl.navigateForward(['/core/home']).then(() => {
      window.location.reload();
    });
  }

  abrirPainelEmpreendedor() {
    this.router.navigate([]).then(result => { window.open(`https://empreendedor.xpory.com/`, '_blank'); });
  }

  onFinalizarConta() {
    this.menu.close('menuPrincipal');
    this.navCtrl.navigateForward(['/excluir-conta']);
  }
}